import * as React from 'react'
import NotFound from '../../routes/not-found'

function WithNotFound(WrappedComponent) {
  return class extends React.Component<any, { notFound: boolean }> {
    constructor(props) {
      super(props)
      this.state = {
        notFound: false
      }
    }

    onNotFound = () => {
      this.setState({
        notFound: true
      })
    }

    render() {
      if (this.state.notFound) {
        return <NotFound />
      }
      return <WrappedComponent onNotFound={this.onNotFound} {...this.props} />
    }
  }
}

export default WithNotFound
